import { getSessionStorageItem } from "./SessionStorage";

export const getPageCount = () => Number(getSessionStorageItem("pageCount"));
